import angular from 'angular';

import abuOrderDetailComponent from './abu-order-detail-component';
import abuUploadSummaryTable from '../abu-upload-summary-table/abu-upload-summary-table';

const abuOrderDetail = angular.module('abuOrderDetail', [abuUploadSummaryTable]);
abuOrderDetail.component('abuOrderDetail', abuOrderDetailComponent);

export default abuOrderDetail.name;
